module.exports = __webpack_public_path__ + "340191a3d5e8bb2353123a3b3d8531f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/informations/aboutUs/Shannon.png
// module id = 1485
// module chunks = 0